const nameData = "ofertas_det"; // Define la entidad dinámica

export const fetchEntityData = async (
  getEntityPanelData,
  searchArtId,
  numPagina,
  filas,
  aofid,
  setListaItems,
  setTotalItems,
  arrayDetalle
) => {
  try {
    let listaOfertas = [];
    let totalApiItems = 0;

    if (aofid) {
      const data = await getEntityPanelData(aofid, searchArtId, numPagina, filas);
      if (data) {
        listaOfertas = data.ofertas_det || [];
        totalApiItems = data.pagination?.totalItems || 0;
      }
    }

    const totalArrayItems = arrayDetalle.length;
    const totalItems = totalApiItems + totalArrayItems;
    const totalPages = Math.ceil(totalItems / filas) || 1;

    // **Combinar API + arrayDetalle**
    const combinedList = [...listaOfertas, ...arrayDetalle];

    // **Aplicar paginación correcta**
    const start = (numPagina - 1) * filas;
    const end = start + filas;
    const paginatedList = combinedList.slice(start, end);

    // **Actualizar estado**
    setListaItems(paginatedList);
    setTotalItems(totalItems);

    return { totalPages };
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};
export const deleteItem = async (deleteEntityData, selectedItem, arrayDetalle, removeItem, getOfertaDetByIdData) => {
  try {

    const detalleEnArray = arrayDetalle.find((item) => item.id === selectedItem);

    if (detalleEnArray) {
      removeItem(selectedItem);
    } else {
      const detalle = await getOfertaDetByIdData(selectedItem);
      if (detalle) {
        await deleteEntityData(selectedItem);
      } else {
        console.error(`No se encontraron datos para el ID: ${selectedItem}`);
      }
    }
  } catch (error) {
    console.error("Ocurrió un error durante la eliminación:", error);
    throw error;
  }
};

